// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
// Analytics 只能在浏览器且已开启 Analytics 的项目里用
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDczGx96LqoDRsXBzAbY7Khbka8YTR6_m8",
  authDomain: "tanyanow1021.firebaseapp.com",
  databaseURL: "https://tanyanow1021-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "tanyanow1021",
  storageBucket: "tanyanow1021.appspot.com",          // ✅ 修正
  messagingSenderId: "374629904845",
  appId: "1:374629904845:web:a83ca8c435625a9b38d484",
  measurementId: "G-447JBT12SM"
};

// 防止开发环境热更新重复初始化
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const db = getDatabase(app);
export const auth = getAuth(app);
